<!--
 * @Author: iRuxu
 * @Date: 2022-04-29 22:34:07
 * @LastEditTime: 2022-07-24 16:51:43
 * @Description:
-->
<template>
    <div class="w-like2" :class="{ disabled:!status }" @click="addLike" v-if="ready">
        <el-tooltip effect="dark" content="点赞" placement="top-start">
            <div>
                <svg data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 396.27 409.74" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="cls-1" d="M127.11 198.5c12.31-5.79 24.16-12.42 36-19.18.89 1.15 2.17.81 3.33.81l124.04.01c22.37 0 44.75-.07 67.13.1 12.68.1 23.36 4.85 31 15.19 10.53 14.18 10.09 32.36-1 46.14-1.34 1.67-1.35 2.68-.07 4.43 13.35 18.21 10.35 39.94-7.38 53.59-1.86 1.43-2 2.62-1.08 4.69 8 17.52 3.62 34.82-11.66 46.51-1.8 1.38-2.25 2.55-1.17 4.66 10.57 20.71-1.1 47.36-26 53.19a32.66 32.66 0 01-5.16.4h-52.06c-6.23 0-12.46-.07-18.69 0-1.77 0-3.73-.72-5.32.76h-42.34c-1.17-1.32-2.74-.69-4.13-.78-11.23-.79-22.44-1.81-33.56-3.66-19.32-3.2-37.88-9-56-16.5 3.47-7.84 4-16.1 4-24.57q-.16-80.27 0-160.54c-.03-1.79.07-3.52.12-5.25z" fill="#fece98"/><path class="cls-2" d="M127.11 198.5c-.05 1.73-.15 3.46-.15 5.19v160.54c0 8.47-.51 16.73-4 24.57-3.69 5.85-8 11.12-13.86 14.94-4.83 3.13-10.38 4.21-15.69 6h-2.4c-1.18-1.34-2.74-.62-4.14-.76-3.53-.37-8.09 1.56-10.36-.86s-.67-6.87-.69-10.43c-.08-16.26 0-32.52 0-48.78a19.62 19.62 0 00-1.71-8.91 11.76 11.76 0 00-13.46-6.09 12 12 0 00-8.92 11.76c.23 19.59 0 39.18.17 58.77 0 3.8-1.16 4.67-4.74 4.6-10.92-.21-21.85-.1-32.78 0-1.39 0-3-.59-4.14.75h-.76c-7.47-3.31-9.5-9.27-9.48-17.08q.25-98.55.1-197.1c0-8.61 2.81-13.23 9.21-14.88a21 21 0 015.14-.49h98c9.89 0 14.5 4.56 14.56 14.34-.04 1.26.05 2.56.1 3.92z" fill="#45a4eb"/><path class="cls-3" d="M10.28 409.74c1.18-1.34 2.75-.74 4.14-.75 10.93-.05 21.86-.16 32.78 0 3.58.07 4.78-.8 4.74-4.6-.2-19.59.06-39.18-.17-58.77a12 12 0 018.92-11.76 11.76 11.76 0 0113.46 6.09 19.62 19.62 0 011.71 8.91c0 16.26-.05 32.52 0 48.78 0 3.56-1.53 8.07.69 10.43s6.83.49 10.36.86c1.4.14 3-.58 4.14.76z" fill="#72c1fd"/><path class="cls-4" d="M283.09 408.96h52.06a3.71 3.71 0 00-.07.74h-52c0-.22 0-.48.01-.74z" fill="#fee0be"/><path class="cls-5" d="M283.09 408.96v.78h-24c1.59-1.48 3.55-.73 5.32-.76 6.22-.09 12.45-.03 18.68-.02z" fill="#fed8ae"/><path class="cls-6" d="M290.48 180.14H166.39c-1.16 0-2.44.34-3.33-.81 10.76-7.12 21.42-14.37 31-23.17 14.3-13.23 25.72-28.4 32.06-47 2.62-7.71 3.65-15.76 5-23.75 2.51-15.26 16-24.5 31.29-21.83 23.67 4.12 39.83 19.31 43.45 42.76 2 13.14.81 26.55-2.11 39.67-2.75 12.01-7.51 23.24-13.27 34.13z" fill="#fec280"/><path class="cls-7" d="M205.48 12.8c0-6.1 3-10.34 8.21-12.14 4.83-1.68 10.65-.14 13.43 4.32 5 8 9.72 16.16 14.14 24.47 2.89 5.42.52 12.16-4.67 15.27-5.5 3.29-12.45 2.22-15.88-3.21-5.11-8.06-9.65-16.48-14.43-24.75a7.11 7.11 0 01-.8-3.96zM332 11.89c0 1.95-.06 3.69-1 5.25-4.63 8.05-9.1 16.2-14 24.09a11.3 11.3 0 01-13.62 4.6c-5.62-2-8.83-6.82-8.28-12.59a10.69 10.69 0 011.2-4.16c4.52-8 9-15.93 13.79-23.76 2.61-4.31 6.89-5.79 11.71-5.09a11.51 11.51 0 019.45 7.6 13.86 13.86 0 01.75 4.06z" fill="#2bccb1"/><path class="cls-8" d="M358.48 112.97c-4.53 0-9.07.14-13.59 0a11.8 11.8 0 01-11.41-12.11 12 12 0 0111.62-11.88q13.4-.21 26.8 0a12 12 0 01.1 24c-.39 0-.79.06-1.19.06h-12.33zM178.92 112.97c-4.53 0-9.07.14-13.59 0-6.56-.26-11.25-5.44-11.19-12.1a11.69 11.69 0 0111.51-11.86q13.38-.21 26.78 0a11.86 11.86 0 0111.45 12 11.7 11.7 0 01-11.37 12c-4.53.13-9.03-.03-13.59-.04z" fill="#2acbb1"/></svg>
                <span class="u-count" v-if="count">{{ count }}</span>
            </div>
        </el-tooltip>
    </div>
</template>

<script>
import { postStat, getStat } from "@jx3box/jx3box-common/js/stat";
export default {
    name: "Like2",
    props: ["postType", "postId"],
    data: function () {
        return {
            status: true,
            count: 0,
        };
    },
    computed: {
        ready() {
            return this.postType && this.postId;
        },
    },
    methods: {
        init: function () {
            this.loadStat();
        },
        loadStat: function () {
            getStat(this.postType, this.postId).then((res) => {
                this.count = res.data.likes || 0;
            });
        },
        // 点赞
        addLike: function () {
            if (!this.ready) return;
            this.count++;
            if (this.status) {
                postStat(this.postType, this.postId, "likes");
            }
            this.status = false;
        },
    },
    watch : {
        postId: {
            handler: function (val) {
                val && this.init();
            },
            immediate: true,
        },
    }
};
</script>

<style lang="less">
@import "../../assets/css/like2.less";
</style>
